(() => {
  if (window.NanaRecipeBox) { window.NanaRecipeBox.boot(); return; }
  const storageKey = 'nana:recipebox:saved:v1';
  let saved = new Set();
  let persistent = true;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
  const readSaved = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(value)) saved = new Set(value.filter(id => typeof id === 'string'));
    } catch { persistent = false; }
  };
  readSaved();
  const rules = {
    beef: /\b(beef|steak|brisket|sirloin|bistec|carne)\b/,
    chicken: /\b(chicken|poultry|pollo)\b/,
    pasta: /\b(pasta|macaroni|spaghetti|fettuccine|noodles|lasagna|lasagne|penne)\b/,
    bread: /\b(flour|bread|tortillas?|dough|buns?|biscuits?|arepas?|empanadas?)\b/,
    vegetables: /\b(tomato|tomatoes|onions?|peppers?|cabbage|carrots?|spinach|vegetables?|potatoes|potato|salsa|beans?|avocado)\b/,
    sweet: /\b(cake|cookies?|dessert|pudding|chocolate|custard|brownies?|tarts?|sweet)\b/
  };
  const cardsFor = section => Array.from(section.querySelectorAll('[data-rb-card]'));
  function refresh(section) {
    const controls = section.querySelector('[data-rb-controls]');
    if (!controls) return;
    const cards = cardsFor(section);
    if (!cards.length && section.hasAttribute('data-nana-specialty') && !section.dataset.rbLoaded) return;
    section.dataset.rbLoaded = 'true';
    controls.hidden = false;
    const labels = JSON.parse(section.querySelector('[data-rb-labels]').textContent);
    const query = normalize(section.querySelector('[data-rb-search]').value.trim());
    const tokens = query.split(/\s+/).filter(Boolean);
    const active = section.querySelector('[data-rb-filter][aria-pressed="true"]')?.dataset.rbFilter || 'all';
    const savedOnly = section.querySelector('[data-rb-saved]').getAttribute('aria-pressed') === 'true';
    const available = new Set();
    let visible = 0;
    cards.forEach((card, index) => {
      if (!card.dataset.rbOrder) card.dataset.rbOrder = String(index + 1);
      const text = normalize(card.dataset.rbText || card.textContent);
      const kinds = new Set((card.dataset.rbKind || '').split(' ').filter(Boolean));
      Object.entries(rules).forEach(([kind, pattern]) => { if (pattern.test(text)) kinds.add(kind); });
      if (section.dataset.collection === 'desserts') kinds.add('sweet');
      kinds.forEach(kind => available.add(kind));
      let bookmark = card.querySelector('[data-rb-save]');
      if (!bookmark) {
        bookmark = document.createElement('button');
        bookmark.type = 'button';
        bookmark.dataset.rbSave = '';
        bookmark.className = 'nrb-bookmark';
        card.append(bookmark);
      }
      bookmark.dataset.rbId = card.dataset.rbId;
      bookmark.classList.add('nrb-bookmark');
      const marked = saved.has(card.dataset.rbId);
      bookmark.setAttribute('aria-pressed', String(marked));
      bookmark.textContent = marked ? '♥' : '♡';
      bookmark.setAttribute('aria-label', (marked ? labels.saved : labels.save) + ': ' + (card.querySelector('h2,h3')?.textContent || card.dataset.rbId));
      bookmark.title = marked ? labels.saved : labels.save;
      const matches = tokens.every(token => text.includes(token)) && (active === 'all' || kinds.has(active)) && (!savedOnly || marked);
      card.hidden = !matches;
      if (matches) visible++;
    });
    section.querySelectorAll('[data-rb-filter]').forEach(button => {
      button.hidden = button.dataset.rbFilter !== 'all' && !available.has(button.dataset.rbFilter) && button.dataset.rbFilter !== active;
    });
    const sorted = cards.slice().sort(section.querySelector('[data-rb-sort]').value === 'az'
      ? (a, b) => (a.querySelector('h2,h3')?.textContent || '').localeCompare(b.querySelector('h2,h3')?.textContent || '')
      : (a, b) => Number(a.dataset.rbOrder) - Number(b.dataset.rbOrder));
    if (sorted.length && sorted.every(card => card.parentElement === sorted[0].parentElement)) sorted.forEach(card => sorted[0].parentElement.append(card));
    const status = section.querySelector('[data-rb-status]');
    status.textContent = (visible ? labels.results.replace('{count}', visible) : labels.empty) + (persistent ? '' : ' ' + labels.temporary);
    const legacy = section.querySelector('[data-specialty-status]');
    if (legacy) legacy.hidden = true;
    section.classList.toggle('nrb-no-results', visible === 0);
  }
  function initialize(section) {
    if (section.dataset.rbBound) return;
    section.dataset.rbBound = 'true';
    const tabs = section.querySelector('.nrb-tabs');
    const revealActive = () => {
      const active = tabs?.querySelector('[aria-current="page"]');
      if (active && tabs.scrollWidth > tabs.clientWidth) tabs.scrollLeft += active.getBoundingClientRect().left - tabs.getBoundingClientRect().left - 12;
    };
    if (tabs && 'ResizeObserver' in window) new ResizeObserver(revealActive).observe(tabs);
    revealActive();
    section.addEventListener('input', event => { if (event.target.matches('[data-rb-search]')) refresh(section); });
    section.addEventListener('change', event => { if (event.target.matches('[data-rb-sort]')) refresh(section); });
    section.addEventListener('click', event => {
      const bookmark = event.target.closest('[data-rb-save]');
      const filter = event.target.closest('[data-rb-filter]');
      const savedButton = event.target.closest('[data-rb-saved]');
      if (bookmark) {
        const id = bookmark.dataset.rbId;
        if (!id) return;
        if (saved.has(id)) saved.delete(id); else saved.add(id);
        try { localStorage.setItem(storageKey, JSON.stringify(Array.from(saved))); } catch { persistent = false; }
        document.querySelectorAll('.nana-recipe-box').forEach(refresh);
      } else if (filter) {
        section.querySelectorAll('[data-rb-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
        refresh(section);
      } else if (savedButton) {
        savedButton.setAttribute('aria-pressed', String(savedButton.getAttribute('aria-pressed') !== 'true'));
        refresh(section);
      } else if (event.target.closest('[data-rb-clear]')) {
        const search = section.querySelector('[data-rb-search]');
        search.value = '';
        section.querySelector('[data-rb-saved]').setAttribute('aria-pressed', 'false');
        section.querySelectorAll('[data-rb-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rbFilter === 'all')));
        search.dispatchEvent(new Event('input', { bubbles: true }));
        refresh(section);
        search.focus();
      }
    });
    refresh(section);
  }
  const boot = () => document.querySelectorAll('.nana-recipe-box').forEach(initialize);
  window.NanaRecipeBox = { boot, refresh };
  document.addEventListener('nana:recipebox-ready', event => { const section = event.target.closest('.nana-recipe-box'); if (section) { initialize(section); section.dataset.rbLoaded = 'true'; refresh(section); } });
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('storage', event => { if (event.key === storageKey) { saved = new Set(); readSaved(); document.querySelectorAll('.nana-recipe-box').forEach(refresh); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
